/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MessageInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MessageInput({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/MessageInput",
  onChange,
  isSubmitting
  
}) {
let paymentsRequestPaymentMessageValueData = fromData.useDataValue({ viewPath,
context: 'payments_request_payment',
path: 'message',
})
let paymentsRequestPaymentMessageChangeData = fromData.useDataChange({ viewPath,
context: 'payments_request_payment',
path: 'message',
})
let paymentsRequestPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_request_payment',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={0}
 data="payments_request_payment.message"
 onChange={paymentsRequestPaymentMessageChangeData}
 value={paymentsRequestPaymentMessageValueData}
 data="payments_request_payment"
 disabled={paymentsRequestPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Instructions for payor (what you are requesting them to pay)"
 weight="medium"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
 backgroundColor={dtColorsWhite}
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}